import clamp from './clamp.js';
import inRange from './inRange.js';
import random from './random.js';

export default {
  clamp, inRange, random
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/number.default.js
// module id = 1273
// module chunks = 0